export type ScreenContext = {
  currentScreen: string;
  previousScreen: string;
};

let screenContextProvider: (() => ScreenContext) | undefined;

export const registerScreenContextProvider = (provider: () => ScreenContext) => {
  screenContextProvider = provider;
};

export const getScreenContext = (): ScreenContext =>
  screenContextProvider?.() ?? { currentScreen: '', previousScreen: '' };
